import script from "./ServiceResourceTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceResourceTree.vue?vue&type=script&setup=true&lang=js"

import "./ServiceResourceTree.vue?vue&type=style&index=0&id=3addf224&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3addf224"]])

export default __exports__